import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
import { resolveVcs, VCS_LINK, VCS_SLUG } from '../../../constants/api';
export const NoRepositories = ({ vcs }) => {
    const { t } = useTranslation();
    if (!vcs) {
        return null;
    }
    const vcsName = resolveVcs(VCS_SLUG[vcs]);
    const values = {
        account: t('account'),
        link: t(vcsName),
        siteName: t('siteName'),
    };
    return _jsxs("div", { className: "content content--no-repositories-page", children: [_jsx("span", { className: `content__picture icon--${vcsName}`, children: "\u00A0" }), _jsx("h2", { className: "content__title", children: t('dontSeeRepositories') }), _jsx("p", { className: "content__text", children: _jsxs(Trans, { i18nKey: "emptyToAnalyze", values: values, children: [t('siteName'), " is designed to continuously watch your git repositories and analyze your commits.", _jsx("br", {}), "It looks like you didn't allow us to see an organization accounts or your account is empty. Check your", _jsxs("a", { href: VCS_LINK[vcs], target: "_blank", rel: "noreferrer", children: [t(vcsName), " account"] }), ", create a repository and hit the", _jsxs("strong", { className: "ml-2 mr-2", children: [_jsx(Icon, { name: "sync-alt", className: "mr-1" }), "Refresh"] }), "button in the top right corner."] }) })] });
};
